// Session côté navigateur — backed par localStorage.
// Le rôle est défini côté serveur (champ user.role retourné par /api/auth/login).
// On ne fait PAS confiance à un rôle calculé côté client.

const KEY = 'cb_auth';

export const getSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// Émet un event interne pour que useSession() rafraîchisse l'UI.
function broadcast() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('cb:session-changed'));
  }
}

export const setSession = (session) => {
  localStorage.setItem(KEY, JSON.stringify(session));
  broadcast();
};

export const clearSession = () => {
  localStorage.removeItem(KEY);
  broadcast();
};

export const getToken = () => getSession()?.token || null;
export const getUser  = () => getSession()?.user  || null;
export const isAdmin    = () => getUser()?.role === 'admin';
export const isLoggedIn = () => Boolean(getToken());
